import './style.css';
import myImagen1 from './img/tranquilidad.jpeg';
import paso1 from './img/mayor.png';
import paso2 from './img/familia.png';
import paso3 from './img/cuidador.png';
import { useState } from 'react';

export const SectionZero = (props) => {


	return (
        <>
            
        <section id="about">
            <div className='container mb-5'>
                <div className='features-main d-flex justify-content-center'>
                    <div className='feature-one d-grid justify-center'>
                        <div className="d-flex align-items-center mb-2">
                            <div className="icon">👤</div>
                            <div>
                                <div className="info-title">Eres cliente</div>
                                <div className="info-subtitle">Encuentra servicios sanitarios y sociosanitarios cerca de ti</div>
                            </div>
                        </div>
                        <div className="highlight-box">
                            <ul>
                            <li><span className="bold-green">Accede a cuidados especializados</span> sin desplazarte</li>
                            <li>Elige entre <span className="bold-green">cientos de profesionales</span> validados</li>
                            <li><span className="bold-green">Compra segura y gestión 100% digital</span></li>
                            <li><span className="bold-green">Asesoramiento</span> personalizado</li>
                            <li><span className="bold-green">Contratación flexible</span> según tus horarios</li>
                            </ul>
                        </div>
                    </div>
                    {/* Se elimina el div separador que ya no es necesario */}
                    {/* <div className='feature-one d-grid justify-center'>
                        <div className="d-flex align-items-center mb-2">
                            <div className="icon">💼</div>
                            <div>
                                <div className="info-title">Eres profesional</div>
                                <div className="info-subtitle">Ofrece servicios sociosanitarios y sociosanitarios in tu zona</div>
                            </div>
                        </div>
                        <div className="highlight-box">
                            <ul>
                            <li><span className="bold-green">Visibilidad inmediata</span> en un marketplace especializado</li>
                            <li><span className="bold-green">Agenda digital</span> y facturación electrónica</li>
                            <li><span className="bold-green">Control de precios y disponibilidad</span></li>
                            <li>Formación, networking y acceso a programas públicos</li>
                            <li><span className="bold-green">Promociona tu negocio</span> sin invertir en publicidad</li>
                            </ul>
                        </div>
                    </div> */}
                </div>

            </div>
            
            {/* <div className="container">
                <div className="titulo-pasos">
                    <h3>En solo <span>3 CÓMODOS PASOS</span></h3>
                </div>
                <div className="container-pasos">
                    <div className="paso">
                        <img src={paso1} alt="paso 1" />
                        <img className='hover-paso' src={hover_paso1} alt="paso 1" />
                    </div>
                    <div className="paso">
                        <img src={paso2} alt="paso 2" />
                        <img className='hover-paso' src={hover_paso2} alt="paso 2" />
                    </div>
                    <div className="paso">
                        <img src={paso3} alt="Paso 3" />
                        <img className='hover-paso' src={hover_paso3} alt="paso 3" />
                    </div>
                </div>
            </div>
            <div className="container my-5">
                <div className="titulo-pasos">
                    <h3>Servicios de cuidado personalizados, a <span>DOMICILIO</span> o en <span>CONSULTA</span>, adaptados a tus necesidades.</h3>
                </div>
            </div> */}
            <div className="container">
                <div className="titulo-pasos">
                    <p className='h3-about'>Tu familia, tus cuidados y tu Historia de Vida, <span>siempre conectados</span></p>
                </div>
                <div className="d-flex flex-wrap res-titulos justify-content-center text-center">
                    <div className="paso p-3 mt-2">
                        <img className='res-img rounded-circle w-25' src={paso1} alt="paso 1" />
                        <div className="p-3">
                            <p className="w-100 h3-about pb-2"> PERSONA MAYOR </p>
                            <p className="text-about">
                                Un <b>entorno sencillo e intuitivo</b>, diseñado para facilitar el acceso a la plataforma. Permite
                                disfrutar de <b>fotografías</b>, vídeos y mensajes, participar en <b>actividades físicas y cognitivas</b>,
                                <b> comunicarse con familiares</b> y <b>acceder fácilmente a los servicios</b> que favorecen la permanencia
                                en el hogar.
                            </p>
                        </div>
                    </div>
                    <div className="paso p-3 mt-2">
                        <img className='res-img rounded-circle w-25' src={paso2} alt="paso 2" />
                        <div className="p-3">
                            <p className="w-100 h3-about pb-2"> FAMILIARES </p>
                            <p className="text-about">
                                Los familiares disponen de un espacio común donde pueden <b>participar en la Historia de Vida</b>,
                                compartir fotografías y vídeos, realizar el <b>seguimiento de los cuidados y servicios recibidos</b>,
                                mantenerse en contacto con los profesionales y <b>acceder a</b> toda la <b>información relevante</b> de la
                                persona desde un único lugar.
                            </p>
                        </div>
                    </div>
                    <div className="paso p-3 mt-2">
                        <img className='res-img rounded-circle w-25' src={paso3} alt="Paso 3"  />
                        <div className="p-3" >
                            <p className="w-100 h3-about pb-2"> CUIDADORES </p>
                            <p className="text-about">
                                Los cuidadores cuentan con <b>acceso autorizado a la información</b> esencial de cada persona,
                                conocen sus rutinas y preferencias, <b>registran las actuaciones realizadas</b> y mantienen una
                                comunicación fluida con la familia, <b>recibiendo</b> además <b>alertas</b> y recomendaciones <b>para</b> ofrecer
                                una <b>atención más personalizada</b>.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container my-5">
                <div className="titulo-pasos">
                    <p className='h3-about'>Servicios de cuidado personalizados, a <span>DOMICILIO</span> o en <span>CONSULTA</span>, adaptados a tus necesidades.</p>
                </div>
            </div>
        </section>
        </>
	);
};
